module.exports = __webpack_public_path__ + "img/24x24_us_photo_see@2x.ed6c23c7.png";